<template>
    <div class="preview-sidebar">
      <div class="preview-sidebar__text_wrap">
        <p class="text-primary">{{ $t('listing_form.remaining_details.you_are_almost_done') }}</p>
        <p class="text-secondary">{{ $t('listing_form.remaining_details.you_are_almost_done_text') }}</p>
      </div>
      <div class="preview-sidebar__left_button_wrap">
        <button class="button button-m button-outline" @click.prevent="continueEditing()">{{ $t('listing_form.remaining_details.back_to_editing') }}</button>
      </div>
      <div class="preview-sidebar__button_wrap">
        <button class="button button-m button-primary" @click.prevent="selectDomain()">{{ $t('listing_form.remaining_details.select_domain') }}</button>
      </div>
    </div>
</template>

<script>
    export default {
        mounted() {
        },
        methods: {
          continueEditing() {
            this.$emit('contin-editing', '')
          },
          selectDomain() {
            this.$emit('select-domain', '')
          }
        }
    }
</script>